import React from 'react'
import '../../../App.css'
import '../About/About.css'
import LeadershipLinks from '../LeadershipLinks';
import ImageComponent from '../../ImageComponent';

function LarryLoden() {
    return (
        <div className='bio-pages main-grid-container'>
          <div className='main-grid-item'>
        <LeadershipLinks/>
        </div>
          <div className='main narrow-grid'>
          <div className='bio-img-wrapper'>
            <ImageComponent src={require('../../../img/larry_loden_bio_portrait_1000px.jpg')}  />
          {/* <img src={require('../../../img/larry_loden_bio_portrait_1000px.jpg')} alt='larry loden portrait' /> */}
            </div>
            <h1 className='bio-header'>Larry Loden</h1>
            {/* <h2 className='bio-subheader'>Pastor-Teacher</h2> */}
            <p> 
            Larry Loden has served Grace Community Fellowship since its beginning.     
            Larry is a Texas native, born and raised in Houston. He studied business at Southwestern University in Georgetown and had a home building career in Houston & Austin.<br/><br/>
            After becoming a Christian at the age of 27, he married Jennifer and later moved to California where he completed his MDiv from the Master’s Seminary in 1999.  He served as an associate pastor at La Crescenta Bible Church in Glendale, California where he was ordained in 2000.<br/><br/>
            He returned to Georgetown in 2002 and began teaching God’s word to small groups in a bi-vocational capacity. This continued until 2007 when, in God’s providence, Grace Community Fellowship was established. Larry has continued to serve the Lord and the families who attend this central Texas congregation ever since.<br/><br/>
            Larry and Jennifer have 4 grown children and 2 grandchildren.
            </p>
          </div>
        </div>
      )
    }

export default LarryLoden
